import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import iView from 'iview'
import inject from './plugins/inject'
import decorate from './plugins/decorate'
import 'iview/dist/styles/iview.css'
import '@/assets/css/iconfont/iconfont.css'
import '@/assets/css/new-icon/iconfont.css'
import '@/assets/css/normallize/normallize.css'
Vue.use(router)
Vue.use(iView)
Vue.use(inject)
Vue.use(decorate)

const performance = process.env.NODE_ENV !== 'production'
Vue.config.productionTip = false
Vue.config.performance = performance

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
